export default {
	'common':{
		'select':'Select',
		'graph_loading': "Loading the data...",
		'month_Names': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		'graph_shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		'graph_day_name': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		'graph_export': "Export",
		'graph_printButt': "Print chart",
		'graph_down_PNG': "Download PNG image",
		'graph_down_JPG': "Download JPEG image",
		'graph_down_PDF': "Download PDF document",
		'graph_down_SVG': "Download SVG vector",
		'graph_zoom_reset': "Reset zoom",
		'Valid request.': 'Valid request.',
		'Warning': 'Warning',
	},
	'main':{
		'titleStatistics':'Statistics',
		'titleManual':'Manual',
		'titleDownload':'Download',
		'titleArchives':'Archives',
		'titleStream':'Stream',
		'titleRealtime':'Realtime',
		'titlePlay':'Running',
		'titleDanger': 'Error/Not Running',
		'titleWarning': 'Running',
		'titleSettings':'Settings',
		'titleSD':'SD free:',
		'titleHDD':'SSD free:',
		'titleCamera': 'CAMERA:',
		'titleLogout': 'Logout',
		'status':'Status',
		'error':'Error',
		'running':'Running',
		'notRunning':'Not Running',
		'downloadingFile':'Downloading file',
		'preparingFile':'Preparing file'
	},
	'login':{
		'Username':'Username',
		'Password':'Password',
		'Login':'Login',
	},
	'dashboard':{
		'measuringTgl':'MEASURING',
		'noiseTgl':'NOISE',
		'weatherTgl':'WEATHER',
		'adioTgl':'ADIO'
	},
	'graphs':{
		'export':{
			'Print chart':'Print chart',
			'Download':'Download',
			'image':'image',
		},
		'nodata': "NO DATA",
		'errNoise': "Problem with Nor140 device",
		'errWeath': "Problem with Weather device",
		'errAdio': "Problem with ADIO device",
		'NOISE':'NOISE',
		'SPECTRUM':'SPECTRUM',
		'WEATHER':'WEATHER',
		'ADIO': 'ADIO',
		'STATISTICS':'STATISTICS',
		'statTitle':'Title',
		'statFrom':'From',
		'statTo':'To',
		'load':'Load',
	    'markers':'Markers',
	    'dailyNotes': 'Daily notes',
	    'preload': 'Manual graph load',
	    'sync': 'Sync graphs',
	    'reset': 'Reset zoom',
	    'exportGraph': 'Export graph',
	    'hideShow': 'Hide / Show',
		'markersCat':{
			'type':'Type',
			'color':'Color',
			'single': 'single',
			'toggle': 'toggle',
			'keybind': 'Keybind',
			'learn':'Learn',
			'shift': 'Shift',
			'alt': 'Alt',
			'delete':'Delete',
			'save': 'Save',
			'note':'Notes',
		},
		'markersTable':{
			'name':'Name',
			'startTime': 'Start time',
			'endTime': 'End time',
			'type': 'Type'
		}
	},
	'calendar':{
		'title': 'Calendar',
		'noise':'Noise',
		'audio':'Audio',
		'weather':'Weather',
		'video':'Video',
		'adio':'ADIO',
	},
	'streamPopover':{
		'title':'Streams',
		'Audio':'Audio',
		'Video':'Video',
		'StartManRec': 'Manual Recording',
		'StopManRec': 'Stop recording',
		'StartStream': 'Start Stream',
		'StopStream': 'Stop stream',
	},
	'download':{
		'title':'Downloads',
		'popOver':{
			'XML':'XML data',
			'XMLWeekly':'XML weekly data',
			'Raw':'Raw data',
			'Global':'Global values',
			'weather':'TXT Weather',
		}
	},
	'archives':{
		'popOver':{
			'Global':'Global values',
			'Noise':'Noise',
			'Audio':'Audio',
			'Video':'Video',
			'Weather':'Weather',
			'Adio': 'ADIO',
			'Compressed': 'Compressed',
		},
		'audioPopOver':{
			'downlRec': 'Download recording',
			'range': 'Range',
		},
		'video':'VIDEO',
		'global':'GLOBAL VALUES',
		'weather':'WEATHER',
		'noise':'NOISE',
		'audio':'AUDIO',
		'name':'Archives',
		'Delete':'Delete',
		'Download':'Download',
		'NorReview':'NorReview',
		'Thumbnail':'Picture',
		'Filename':'Filename',
		'Duration':'Duration',
		'Size':'Size',
		'Close':'Close',
		'adio': 'ADIO',
		'compressed': 'COMPRESSED FILES',
	},
	'settings':{
		'name':'SETTINGS',
		'save':'SAVE',
		'addButt':'ADD',
		'preTrigg': 'Pre-Trigger',
		'Trigg': 'Trigger',
		'postTrigg':'Post-Trigger',
		'warning': 'Warning',
		'continue': 'Continue',
		'cancel': 'Cancel',

		'interface':{
			'settingsName':'View',
			'Realtime display':'Realtime display [sec]',
			'Language':'Language',
			'Lt':'Noise graph y-range',
			'Spectrum':'Spectrum graph y-range',
			'Weather':'Weather graph y-range',
			'Adio': 'ADIO IN graph y-range',
			'Manual':'Manual range',
			'Dynamic':'Dynamic range',
			'noiseTriggerLevel':'Noise trigger level',
			'spectrumTriggerLevel':'Spectrum trigger level',
			//Options
			'english':'English (EN)',
			'austria':'German (AT)',
			'german':'German (DE)',
			'french':'French (FR)',
			'slovensko':'Slovenian (SLO)',
		},
		'download':{
			'settingsName':'Download',
			'Compression':'Compression',
			'No compression':'No compression',
			'Zip compression':'Zip compression (saves bandwidth)',
			'Noise':'Noise',
			'Weather':'Weather',
			'Global Values':'Global Values',
			'Special values':'Special values',
			'Audio':'Audio',
			'Video':'Video',
			'Markers':'Markers',
			'Statistics':'Statistics',
			'statisticsTemplate':'Template',
			'statisticsRename':"Rename Template"
		},
		'audioRecording':{
			'settingsName':'Audio recording',
			'Format':'Format',
			'Audio Offset':'Audio pre-trigger: [s]',
			'Day':'Day',
			'Night':'Night',
			'Optional 1':'Optional 1',
			'Optional 2':'Optional 2',
			'RecDur':'Rec dur (s)',
			'Threshold':'Threshold (dBA)',
			'Start':'Start time (HH)',
			'Stop':'Stop time (HH)',
			'Weather':'Weather trigger',
			'Windspeed':'Windspeed',
			'Temperature':'Temperature',
			'Air':'Air pressure',
			'Precipitation':'Precipitation',
			'Humidity':'Humidity',
			//Options
			'Disable':'Disabled',
			'Lower':'Lower than',
			'Greater':'Greater than',
			'Both':'Both',
			'lowerThan':'Lower than',
			'greaterThan':'Greater than',
		},
		'dynamicDns':{
			'settingsName':'Dynamic Dns',
			'Address':'Address',
			'Provider':'Provider',
			'Username':'Username',
			'Password':'Password',
			'IP':'IP',
		},
		'alertMessaging':{
			'settingsName':'Alert messaging',
			'createGroupButton':'Create new group',
			'createGroupDialog':'Are you sure you want to create a new Group?',
			'deleteGroupDialog':'Are you sure you want to delete Group ',
			'deleteEmailDialog':'Are you sure you want to delete this E-mail / Telephone number ?',
			'dialogConfirm':'Confirm',
			'dialogContinue':'Continue',
			'dialogCancel':'Cancel',
			'MSISDN-E-Mail':'To which group(s) do you want to add recipient?',
			'Add MSISDN':'Add Telephone number',
			'Add E-mail':'Add E-mail',
			'DeleteButton': 'Delete',
			'DeleteGroup':'Delete group',
			'DeleteRecip': 'Delete Recipient',
			'DeleteEmail':'Delete E-mail / Telephone number',
			'TestEmail':'Send test E-mail / SMS',
			'Resend after':'Resend after',
			'Threshold day':'Threshold day',
			'Threshold Night':'Threshold Night',
			'Threshold Opt 1':'Threshold Opt 1',
			'Threshold Opt 2':'Threshold Opt 2',
			'Running Average Level':'Moving value Level',
			'Weather trigger': 'Weather Trigger',
			'System reboot':'System reboot',
			'Connection with meter lost':'Connection with Nor140 lost',
			'FTP server error':'FTP server error',
			'Critical memory on meter':'Critical memory on Nor140',
			'Critical disk space':'Critical disk space',
			'Microphone check error':'Microphone check error',
			'Battery mode':'Battery mode',
			'Connection with Weather station lost':'Connection with Weather station lost',
			'LEQ':'LEQ Day',
			'Inbound (MSISDN)':'Inbound (SMS)',
			'Status':'Status:',
			'GPS':'GPS:',
			'Threshold change':'Threshold change:',
			'Email settings':'Email settings:',
			'Sender Email':'Sender Email',
			'Password':'Password',
			'SMTP server':'SMTP server',
			'SMTP port':'SMTP port',
			'noRepeat':'No repeat',
			'resendAft':'Resend after',
			//Options
			'min':'min',
			'disabled':'Disable',
			'groupsError':'Please select groups!',
			'emailSent':'Message successfuly sent'
		},
		'FTPSending':{
			'settingsName':'FTP sending',
			'FTP Address':'FTP Address',
			'Refresh Rate':'Refresh Rate',
			'Username':'Username',
			'Password':'Password',
			'Port':'Port',
			'Values':'Values to send',
			//Options
			'Disable':'Disable',
			'sec':'sec',
			'min':'min',
			'hour':'hour',
			'measur':'Noise',
			'weath':'Weather',
			'audio':'Audio',
			'global':'Global',
			'video':'Video',
		},
		'geographicPosition':{
			'settingsName':'Geographic position',
			'Latitude':'Latitude[°]',
			'Longitude':'Longitude[°]',
			'Height':'Height[m]',
		},
		'weather':{
			'settingsName':'Weather',
			'Weather':'Weather station',
			'values':'Values',
			'SetDevice':'Set Device',
			//Options
			'NoWeather':'No weather station',
			'reinhardt':'Reinhardt MWS 5MV',
			'reinhardtRain':'Reinhardt MWS 5MV with Rain',
			'thiesClima':'Thies Clima sensor US',
			'vaisala':'Vaisala WXT520',
			'kw360': 'ONWA KW-360',
		},
		'delete':{
			'settingsName':'Delete/Compress',
			'autoDelete':'Auto-delete older than',
			'autoCompress':'Auto-compress older than',
			'Disable':'Disable',
			'Manual delete':'Manual delete',
			'Values':'Values',
			'Delete':'Delete',
			//Options
			'day':'day',
			'week':'week',
			'month':'month',
			'measur':'Noise',
			'weath':'Weather',
			'audio':'Audio',
			'global':'Global',
			'logs':'Logs',
			'statistics':'Statistics',
			'video':'Video',
			'adio': 'ADIO'
		},
		'device':{
			'settingsName':'Nor 140',
			'Selection':'MIC Selection',
			'Polarisation':'MIC Polarisation',
			'Frequency':'Frequency mode',
			'Resolution':'Resolution',
			'Duration':'Duration',
			'Meter':'Meter scale',
			'Values':'Values',
			'Special':'Special parameters',
			'Advance':'Advance',
			'Mic check':'Mic check value [dB]:',
			'Mic check time':'MIC check at [HH]:',
			'SDFreeSpace':'SD Free space alert [%]',
			'Restart':'Restart noise',
			'Set instrument':'Set instrument',
			'Format':'Format SD',
			'CheckSD':'Check SD Free space',
			'formatSDdialog':'This action can take up to 5 minutes, do you still wish to continue?',
			'decrease':'Decrease',
			'increase':'Increase',
			'value':'Value',
			'threshold':'Threshold (dBA)',
			'timeControlled':'Time controlled',
			'measurementControlled':'Measurement controlled',
			'start_stop':'Start time / Stop time',
			'startTime':'Start time',
			'endTime':'End time',
			'trigger':'Trigger',
			'duration':'Duration',
			'test':'Test',
			'testOpt': 'Test for installed options',
			'restartNoise':'Restart noise',
			'increasedVol': 'Increased Volume',
			'decreasedVol': 'Decreased volume',
			'autostart': 'Auto Start-Stop',
			//Options
			'On':'On',
			'Off':'Off',
			'Standard':'Standard',
			'Disable':'Disable',
			'iepe':'IEPE',
			'line':'Line',
			'horizontal':'1214/16/17 Horizontal',
			'vertical':'1214/16/17 Vertical',
			'11octave':'1/1 Octave',
			'13octave':'1/3 Octave',
			'11wOctave':'1/1w Octave',
			'13wOctave':'1/3w Octave',
			'movingAverage':'Moving Average',
			'movingValue': 'Moving value',
			'midnight': "Midnight - 00h",
			'noon': "Noon - 12h",
			'freeSpace': 'SD Free space: ',
			'instrumentSent': 'Instrument set',
			'start':'Start',
			'stop':'Stop',
			'days':'Days',
			'types':'Types',
			'startstopActive':'Active',
			'warningMeasRunning':'Values will not be sent to instrument if the measurement is running!'
		},
		'video':{
			'settingsName':'Video',
			'Present':'Present',
			'Manual':'Manual recording',
			'Triggering':'Threshold triggering video',
			'Moving detection':'Moving detection',
			'Settings':'Settings',
			'Pre':'Pre-record',
			'Post':'Post-record',
			'No device':'No device',
			'Video camera':'Video camera',
			'SetDevice': 'Set Device',
			'formatSDWarning': 'Please wait until SD card free space indicatior is on 100%'
		},
		'adio':{
			'settingsName':'ADIO',
			'Present':'Present',
			'ADIO':'ADIO Box',
			'NoDevice':'No device',
			'DigitalOut':'Digital Out',
			'DigitalIn':'Digital In',
			'AnalogIn':'Analog In',
			'AnalogOut':'Analog Out',
			'AnalogLowerLimit':'Analog lower limit 0V / 4mA',
			'AnalogUpperLimit':'Analog upper limit 10V / 20mA',
			'Pleaseinput':'"Please input"',
			//Options
			'On':'On',
			'Off':'Off',
		},
		'norcloud':{
			'settingsName':'NorCloud',
			'IdNor':'Nor140 ID',
			'syncTime':'Synchronization Time',
			'syncData': 'Send Noise Data',
			'syncRec': 'Send Audio Recordings',
			'sendAlerts': 'Send Alerts',
			'recSett': 'Receive Settings',
			'applySett': 'Apply Received Settings',
			//Options
			'On':'On',
			'Off':'Off',
			'disable':'Disable',
			'min':'min',
			'hour':'hour',
			'now': 'When settings are recevied',
			'fhour': 'At full hour',
			'break': 'When Automic check is performed',
		},
		'statistics':{
			'settingsName':'Statistics',
			'reportSending':{
				'settingsName': 'Automatic Report Sending',
				'Name': 'Name',
				'Title': 'Title',
				'Duration': 'Report type',
				'Days': 'Sending days',
				'Hours': 'Send at',
				'Range': 'Past days',
				'Email': 'E-mail' ,
				'Language':'Language',
			},
			'options': {
				'Range': 'Range',
				'Daily': 'Daily',
				'On Event': 'On Event',
			}
		},
		'status':{
			'settingsName':'System',
			'Reboot':'Reboot System',
			'Reboot confirm': 'Are you sure you want to reboot system?',
			'Reboot success': 'Less than 1min to Reboot!',
			'Reboot cancel': 'Reboot canceled',
			'Restart confirm':'Are you sure you want to Restart N140?',
			'Restart Warning': 'N140 will be back online in 1min!',
			'Restart success': 'N140 is back online!',
			'Restart cancel': 'Canceled',
			'Version':'Version',
			'Release':'Release date',
			'PCFree':'PC free space alert [%]',
			'SDD':'SSD',
			'memory':'Memory',
			'camera':'Camera SD',
			'n140':'Nor140 SD',
			'cpu':'CPU Percent',
			'firmware':'Firmware',
			'logs':'Logs',
			'download':'Download',
			'total':'TOTAL',
			'free':'FREE',
			'used':'USED',
			'gbOrMore':'2GB or more',
			'of':'of',
			'users': 'Users',
			'username':'Username',
			'password':'Password',
			'adminUsr': 'Admin',
			'noiseUsr': 'Normal',
			'guestUsr': 'Guest'
		}
	},
	'errors':{
		'n140':'Nor140',
		'weather': 'WEATHER STATION',
		'adio': 'ADIO',
		'cameraSD':'CAMERA SD Card over 80% full!'
	},
	'codes':{
		"13":"No serial connection",
		"16":"Software options missing",
		"64":"OK-no error",
		"89":"Measurement time too long for Synchro",
		"90":"Command unknown",
		"91":"Option not present",
		"92":"I/O locked",
		"93":"No marker table for selected file",
		"94":"Command string to long without delimiters",
		"97":"Device error",
		"99":"No DECT module detected",
		"100":"No digit read",
		"101":"Number is illegal",
		"102":"Text string too long",
		"104":"No data valid",
		"105":"Number out of range",
		"106":"Measurement not started",
		"108":"Timeout on string parameter to a command",
		"109":"Software v2.x option no present (118)",
		"110":"Error in text format",
		"111":"Software v3.x option not present (118)",
		"112":"Memory full",
		"116":"All memory operations blocked due to memory errors",
		"117":"Audiometer Calibration parameter error",
		"118":"Not define error",
		"119":"Not define error",
		"121":"Directory NOT set",
		"122":"Directory NOT found",
		"123":"Memory operation OK",
		"124":"SD Card NOT present",
		"125":"SD Card NOT powered",
		"126":"SD Card write protected"
	}
}



// WEBPACK FOOTER //
// ./src/localization/translations/local-EN.js